import React from 'react';
import { Filter, SelectInput } from 'react-admin';
import { managers_select } from '../../../../config/constants';
import { CustomDateInput } from '../../../../commonComponents/CustomDateInput';

const ManagersActivityReportsFilter = (props) => (
  <Filter {...props}>
    <SelectInput label="Role" source="select_role" choices={managers_select} alwaysOn />
    <CustomDateInput label="Choose start date" source="start_date" start alwaysOn />
    <CustomDateInput label="Choose end date" source="end_date" end alwaysOn />
  </Filter>
);

export default ManagersActivityReportsFilter;
